import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';
import { ADDENDUM_IN_PROGRESS } from '../../../../../constants/reports';

const PiaExceptionReportTableRow = ({ rowData, id, slNo }) => {
  const {
    opid,
    contractNumber,
    firstName,
    middleName,
    lastName,
    remainingInterest,
    remainingBalance,
    location,
    locationId,
    agreementType,
    addendumStatus,
  } = rowData;
  let { businessEntity } = rowData;
  if ((agreementType === 1 || agreementType === 2) && (locationId === 1 || locationId === 3)) {
    businessEntity = 'Cremation';
  } else if (businessEntity === 'Cemetry') {
    businessEntity = 'Cemetery';
  }
  const name = middleName?.length
    ? `${firstName} ${middleName} ${lastName}`
    : `${firstName} ${lastName}`;
  return (
    <tr key={id} className="pia-tr">
      <td>{slNo}</td>
      <td>{opid || '-'}</td>
      <td className="addendum">
        <p>{contractNumber || '-'}</p>
        {addendumStatus === ADDENDUM_IN_PROGRESS && (
          <p className="addendum-note">Note: Addendum In Progress</p>
        )}
      </td>
      <td>{name}</td>
      <td>{getPrice(remainingInterest)}</td>
      <td>{getPrice(remainingBalance)}</td>
      <td>{location || '-'}</td>
      <td>{businessEntity || '-'}</td>
    </tr>
  );
};

PiaExceptionReportTableRow.propTypes = {
  rowData: PropTypes.shape({
    opid: PropTypes.string,
    remainingInterest: PropTypes.number,
    remainingBalance: PropTypes.number,
    firstName: PropTypes.string,
    middleName: PropTypes.string,
    lastName: PropTypes.string,
    location: PropTypes.string,
    contractNumber: PropTypes.string,
    businessEntity: PropTypes.string,
    locationId: PropTypes.number,
    agreementType: PropTypes.number,
    addendumStatus: PropTypes.string,
  }).isRequired,
  id: PropTypes.number.isRequired,
  slNo: PropTypes.number.isRequired,
};

export default PiaExceptionReportTableRow;
